import { settings } from "@/scripts/settings";
import languages, { type language } from "../utils/translations";
export default languages[settings.language] as language;
